import React from 'react';
import { Box, Container, Skeleton } from '@mui/material';

// 999.2131 (brand Loading & Busy-State Standard, rule 7 — admin not exempt):
// shared skeleton page shell replacing the copy-pasted full-page centered
// CircularProgress across ~18 admin pages. Header bar + table-ish rows so
// nothing jumps when the real page lands. Precedent: AiUsage* widgets.
export default function AdminPageSkeleton({ rows = 6, bare = false }) {
  // bare: section-level use inside an existing page Container (avoids nested
  // Container gutters); default renders the full page shell.
  const Wrapper = bare ? Box : Container;
  const wrapperProps = bare
    ? { sx: { py: 2 } }
    : { maxWidth: 'lg', sx: { py: 4 } };
  return (
    <Wrapper {...wrapperProps} aria-busy="true" data-testid="admin-page-skeleton">
      {!bare && <Skeleton variant="text" width="30%" height={40} sx={{ mb: 2 }} />}
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} variant="rectangular" height={44} sx={{ mb: 1, borderRadius: '2px' }} data-testid="admin-page-skeleton-row" />
      ))}
      <Box role="status" sx={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
        Loading…
      </Box>
    </Wrapper>
  );
}
